export class SearchItem {
  constructor() {}

  itemId: string;
  name: string;
  picture: string;
  isMovie: boolean;
}



// WEBPACK FOOTER //
// ./src/data/SearchItem.ts